import { ChapterListPage } from './ChapterListPage';
export default ChapterListPage;
